import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Button as ButtonComponent } from '@raisin/components-lib';

export const RiskBannerContainer = styled(Grid)(() => ({
  '& > div': {
    maxWidth: '100%',
  },
}));

export const DetailsContainer = styled(Grid)({
  cursor: 'auto',
});

export const HeaderTabsContainer = styled(Grid)({
  '.tab-panel-box': {
    paddingLeft: 0,
    paddingBottom: 0,
  },
});

export const Button = styled(ButtonComponent)({
  justifyContent: 'left',
});

export const BankOffersDetailFields = styled(Grid)(({ theme }) => ({
  '&:last-child .wrapper': {
    padding: theme.spacing(4, 0, 0, 0),

    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },

    '.MuiTypography-root .MuiBox-root': {
      margin: 0,

      '&:first-child': {
        marginBottom: theme.spacing(2),
      },
    },
  },
}));

export const DetailFieldBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 0),

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 0, 6, 0),
  },
}));
